import { render } from "./QuranAyatBacaanku.vue?vue&type=template&id=0010a838"
import script from "./QuranAyatBacaanku.vue?vue&type=script&lang=js"
export * from "./QuranAyatBacaanku.vue?vue&type=script&lang=js"
script.render = render

export default script